import type { RestrictionType } from '../filterTypes';

/**
 * Maps restriction type to API params.
 * 'income' → { incomeRestricted: true }
 * 'senior' → { seniorHousing: true }
 * 'none' → {} (hide restricted — API default excludes restricted)
 * null → {} (any — no filter)
 */
export function restrictionToApiParams(
  restriction: RestrictionType | null,
): Record<string, boolean> {
  if (restriction === null || restriction === 'none') return {};

  const mapping: Record<string, Record<string, boolean>> = {
    income: { incomeRestricted: true },
    senior: { seniorHousing: true },
    student: { studentHousing: true },
    military: { militaryHousing: true },
  };

  return mapping[restriction] ?? {};
}
